"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToHeaderCart = addToHeaderCart;
exports.headerCartEvents = void 0;
exports.openHeaderCart = openHeaderCart;
exports.useHeaderCartEvent = useHeaderCartEvent;
/* eslint-disable filenames/match-regex */
const headerCartEvents = exports.headerCartEvents = {
  ENABLE: 'px.headerCart.enable',
  MOUNTED: 'px.headerCart.mounted',
  ADD: 'px.headerCart.add',
  REMOVE: 'px.headerCart.remove',
  UPDATE: 'px.headerCart.update',
  PROPS: 'px.headerCart.props',
  ADD_PENDING: 'px.headerCart.addPending',
  REFRESH: 'px.headerCart.refresh',
  OPEN: 'px.headerCart.open',
  CLOSE: 'px.headerCart.close',
  CLOSED: 'px.headerCart.closed',
  ERROR: 'px.headerCart.error'
};
function openHeaderCart({
  actionKey = '',
  configKey = ''
} = {}) {
  if (actionKey !== '' || configKey !== '') {
    document.dispatchEvent(new CustomEvent(headerCartEvents.OPEN, {
      detail: {
        features: {
          actionKey,
          configKey
        }
      }
    }));
  } else {
    document.dispatchEvent(new CustomEvent(headerCartEvents.OPEN));
  }
}
async function addToHeaderCart({
  productPackage,
  term,
  itc,
  addToCartUrl,
  onError = async () => null
}) {
  // CustomEvent instead of Event ...
  document.dispatchEvent(new CustomEvent(headerCartEvents.ADD_PENDING));
  const body = JSON.stringify({
    packages: [{
      pkgid: productPackage,
      term
    }],
    itc
  });
  try {
    await fetch(addToCartUrl, {
      method: 'POST',
      body,
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Call to service failed', error);
    await onError(error);
  }
  document.dispatchEvent(new CustomEvent(headerCartEvents.REFRESH));
}

// callbacks should be using useCallback React hook for optimization
function useHeaderCartEvent(event, callback) {
  global?.document?.addEventListener(event, callback);
  return () => {
    global?.document?.removeEventListener(headerCartEvents.event, callback);
  };
}